import {
  DownloadRounded as DownloadRoundedIcon,
  NavigateNextRounded as NavigateNextRoundedIcon,
} from '@mui/icons-material';
import { Box, Card, CardActionArea } from '@mui/material';

export const BotonDescargaApp = ({ content, arialLabel }) => {
  return (
    <Card sx={{ border: 'none', boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.08)' }}>
      <CardActionArea
        aria-label={'Instalar Aplicación. Acceso rápido desde tu pantalla de inicio.'}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px',
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              p: 1,
            }}
          >
            <DownloadRoundedIcon sx={{ color: 'rgba(0,0,0,0.5)' }} />
          </Box>
          {content || 'Instalar / Descargar Aplicación'}
          <NavigateNextRoundedIcon sx={{ color: 'rgba(0,0,0,0.5)' }} />
        </Box>
      </CardActionArea>
    </Card>
  );
};
